import { CdkAccordion, CdkAccordionItem } from '@angular/cdk/accordion';
import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ClientEditor } from '../../../../models/clients.model';

@Component({
  selector: 'app-client-editor-list',
  imports: [CdkAccordion, CdkAccordionItem, MatIcon, DatePipe],
  templateUrl: './client-editor-list.component.html',
  styleUrl: './client-editor-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientEditorListComponent {
  public readonly items = input<ClientEditor[]>([]);
}
